import { QueryFactory } from "../../../../Common";
export const QGetSettledBets = QueryFactory("GetSettledBets");
//# sourceMappingURL=QGetSettledBets.js.map